import { Card, CardContent } from "@/components/ui/card";

import type { SourcingMeta } from "./api";
import { PageTrail, Trail } from "./links";
import { PAGES } from "./pages";
import { PageHead } from "./pages/kit";
import { PageFilters } from "./pages/PageFilters";
import { usePageMeta } from "./pageMeta";
import { RefreshData } from "./RefreshData";
import { tabFor } from "./routes";
import { SharedFilterBar, useFilterOptions } from "./SharedFilterBar";

export const COMING_NEXT = "This page is coming next.";

export function useSourcingFunnelMeta(enabled: boolean): SourcingMeta | null | undefined {
  const head = useFilterOptions(null, enabled);
  const pageMeta = usePageMeta();
  return enabled ? (pageMeta ?? head.data?.meta) : undefined;
}

export function SourcingFunnelModule({
  activeTabKey,
  areaName,
}: {
  decision: "edit" | "view" | "none";
  activeTabKey: string | null;
  areaName: string;
  ownerName?: string | null;
}) {
  const tab = tabFor(activeTabKey);
  const Page = PAGES[tab.tabKey];
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <PageTrail current={tab.tabKey} />
        <Trail current={tab.tabKey} />
        <SharedFilterBar tab={tab} />
        <PageFilters tab={tab} />
      </div>
      <Card>
        <CardContent className="flex flex-col gap-3">
          {/* Once per module render, so every page (TabPage, RowsPage or its own frame) has exactly one (bug 6cc4e876). */}
          <RefreshData />
          {Page ? (
            <Page tab={tab} areaName={areaName} />
          ) : (
            <>
              <PageHead title={tab.label} />
              <p className="py-8 text-center text-ks-grey-1">{COMING_NEXT}</p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
